// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"7d4d17c0","931":"2ecc8960"}[chunkId] + ".chunk.js";
};